export const getMainFiltersVisibility = (store) =>
	store.Filters.isMainFiltersVisible || false;
